import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, TextField, Button, Snackbar, Alert, Paper, Grid,
} from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import { createOtros, getPacienteByCodigo } from '../api/otrosApi';

const FORM_COLORS = {
  primary: '#0d6aee',
  textMain: '#0f172a',
  textMuted: '#475569',
  border: '#dbe7f3',
};

const sectionPaperSx = {
  p: { xs: 2, md: 3 },
  mb: 3,
  borderRadius: 3,
  border: `1px solid ${FORM_COLORS.border}`,
  background: '#f8fbff',
  boxShadow: '0 4px 12px rgba(15,23,42,0.04)',
};

const Otros = ({ codigo }) => {
  const navigate = useNavigate();
  const [lawtonBrody, setLawtonBrody] = useState('');
  const [moca, setMoca] = useState('');
  const [openGood, setOpenGood] = useState(false);
  const [openError, setOpenError] = useState(false);

  const guardarDatos = async () => {
    try {
      const paciente = await getPacienteByCodigo(codigo);
      const userId = localStorage.getItem('id');
      await createOtros(paciente.id, userId, {
        lawtonBrody: parseInt(lawtonBrody),
        moca: parseInt(moca),
      });
      setOpenGood(true);
      setTimeout(() => { navigate('/home'); }, 1500);
    } catch (error) {
      setOpenError(true);
      console.error('Error al guardar los datos:', error);
    }
  };

  return (
    <DashboardLayout>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: 3 }}>
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 800,
            p: { xs: 2, md: 4 },
            borderRadius: 4,
            border: `1px solid ${FORM_COLORS.border}`,
          }}
        >
          <Typography variant="h4" sx={{ textAlign: 'center', color: FORM_COLORS.textMain, fontWeight: 700, mb: 1 }}>
            Cuestionario Otros
          </Typography>
          <Typography sx={{ textAlign: 'center', color: FORM_COLORS.textMuted, mb: 4 }}>
            Valoración cognitiva y funcional del paciente.
          </Typography>

          <Paper elevation={0} sx={sectionPaperSx}>
            <Typography variant="h6" sx={{ color: FORM_COLORS.textMain, fontWeight: 700, mb: 2 }}>
              Identificación del paciente
            </Typography>
            <TextField
              label="Código del Paciente"
              variant="outlined"
              value={codigo}
              fullWidth
              InputProps={{ readOnly: true }}
              size="small"
            />
          </Paper>

          <Paper elevation={0} sx={sectionPaperSx}>
            <Typography variant="h6" sx={{ color: FORM_COLORS.textMain, fontWeight: 700, mb: 2 }}>
              Valoración cognitiva y funcional
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="LAWTON Y BRODY (puntos)"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={lawtonBrody}
                  onChange={(e) => setLawtonBrody(e.target.value)}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="MOCA (puntos)"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={moca}
                  onChange={(e) => setMoca(e.target.value)}
                  size="small"
                />
              </Grid>
            </Grid>
          </Paper>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={guardarDatos}
              sx={{ borderRadius: 2.5, px: 4 }}
            >
              Guardar Datos
            </Button>
          </Box>
        </Paper>
      </Box>

      <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
        <Alert severity="success" onClose={() => setOpenGood(false)}>¡Datos guardados correctamente!</Alert>
      </Snackbar>
      <Snackbar open={openError} autoHideDuration={2000} onClose={() => setOpenError(false)}>
        <Alert severity="error" onClose={() => setOpenError(false)}>No hay pacientes con ese código.</Alert>
      </Snackbar>
    </DashboardLayout>
  );
};

export default Otros;
